import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ErrorViewer from "../ErrorViewer";
import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import {string} from "yup";
import BaseDatePicker from "../Base/BaseDatePicker";
import {useAppSelector} from "../../redux/hooks";
import {FaArrowLeft} from "react-icons/fa";

interface PropsI {
    nextPage: (values: any) => void;
    prevPage: () => void;

}

const EmailPhone = ({ nextPage, prevPage }: PropsI)=>{
    const { isLoading } = useAppSelector((state) => state?.auth);
    const validationSchema = Yup.object().shape({
        email: Yup.string().required("Email is required"),
        dateOfBirth: Yup.string().required("Date of Birth is required"),
        mobileNumber: Yup.string().required("Mobile Number is required"),
    });

    const { handleSubmit, register, setValue, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            email: "",
            dateOfBirth: new Date().toISOString(),
            mobileNumber: "",
        }
    });

    const onSubmit = (values: any) =>{
        nextPage(values)
    }

    return (
        <div>
            <button className="btn btn-outline mb-4" onClick={prevPage}>
                <FaArrowLeft className="mr-2"/>
                Back
            </button>
            <div className="input_container">
                <label className="input_title" htmlFor="email">
                    Email Address
                </label>
                <input
                    id="email"
                    className="input_field"
                    type="text"
                    placeholder={"Enter email address"}
                    {...register("email")}
                />
                {errors.email && (
                    <ErrorViewer message={errors.email.message as string}/>
                )}
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="phone-number">
                    Phone Number
                </label>
                <input
                    id="phone-number"
                    className="input_field"
                    type="text"
                    placeholder={"Enter Phone Number"}
                    {...register("mobileNumber")}
                />
                {errors.mobileNumber && (
                    <ErrorViewer message={errors.mobileNumber.message as string}/>
                )}
            </div>
            <div className="input_container">
                <label className="input_title" htmlFor="date-of-birth">
                    Date of Birth
                </label>
                <BaseDatePicker
                    id="date-of-birth" onChange={(date) => {
                    setValue('dateOfBirth', date.toISOString());
                }}/>
                {errors.dateOfBirth && (
                    <ErrorViewer message={errors.dateOfBirth.message as string}/>
                )}
            </div>


            <button
                onClick={handleSubmit(onSubmit)}
                className="btn btn-primary btn-primary-full"
                disabled={isLoading}
            >
                {!isLoading ? (
                    "Signup"
                ) : (
                    <LoadingSpinner color={"#305F32"} backgroundColor={""}/>
                )}
            </button>
        </div>
    );
}

export default EmailPhone;